import { parseBlocks } from '../utils/markdown.ts';

/** おじさんの発言。Markdown の最小構成だけを解釈して表示する。 */
export function OjisanBubble({ text, streaming }: { text: string; streaming: boolean }) {
  const blocks = parseBlocks(text);

  return (
    <div className="bubble bubble--ojisan">
      {blocks.map((block, blockIndex) =>
        block.type === 'p' ? (
          <p key={blockIndex}>
            {block.parts.map((part, i) =>
              part.strong ? <strong key={i}>{part.text}</strong> : <span key={i}>{part.text}</span>,
            )}
            {streaming && blockIndex === blocks.length - 1 ? <span className="caret" /> : null}
          </p>
        ) : (
          <ul key={blockIndex}>
            {block.items.map((item, i) => (
              <li key={i}>
                {item.map((part, j) =>
                  part.strong ? <strong key={j}>{part.text}</strong> : <span key={j}>{part.text}</span>,
                )}
              </li>
            ))}
          </ul>
        ),
      )}
      {streaming && blocks.length === 0 ? <span className="caret" /> : null}
    </div>
  );
}

export function UserBubble({ text }: { text: string }) {
  return <div className="bubble bubble--user">{text}</div>;
}
